<template>
    <div>
        <div class=" flex-n fac fjb content1">
            <div class="flex-n fac">
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        maxlength="16"
                        placeholder="输入名称"
                        title="输入名称"
                        clearable
                        prefix-icon="el-icon-search"
                        v-model="customFrom">
                </el-input>
            </div>
            <div class="flex-n fac">
                <el-button type="primary" class="ele-btn2" @click="searchList">查询</el-button>
                <el-button type="primary" class="ele-btn2" @click="addUserFrom">新增</el-button>
            </div>
        </div>
        <div class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="orderIndex"
                        label="排 序"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="customFrom"
                        label="名 称"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="状 态"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.customFromState=='0'?'启用':'停用'}}
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="180"
                        align="center">
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small mr-10" @click="editUserFrom(scope.row.id)">编辑</el-button>
                            <template v-if="scope.row.customFromState=='1'">
                                <el-popconfirm
                                        title="确定启用客户来源吗？（启用客户来源能正常使用）"
                                        @confirm="manageUserFrom(0,scope.row)"
                                >
                                    <el-button  slot="reference" type="primary" class="ele-btn-small mr-10">启用</el-button>
                                </el-popconfirm>
                            </template>
                            <template v-else>
                                <el-popconfirm
                                        title="确定停用客户来源吗？（停用的客户来源不能再被选择）"
                                        @confirm="manageUserFrom(1,scope.row)"
                                >
                                    <el-button  slot="reference" type="primary" class="ele-btn-small mr-10">停用</el-button>
                                </el-popconfirm>
                            </template>

                            <el-popconfirm
                                    title="确定删除客户来源吗？（删除客户来源会删除关联数据，若不想移除，请使用停用功能）"
                                    @confirm="delUserFrom(scope.row.id)"
                            >
                                <el-button  slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </div>
        <edit-user-from :visible.sync="visible" :id="id" :type="type"></edit-user-from>
    </div>
</template>

<script>
    import EditUserFrom from "./EditUserFrom";
    import Pagination from "../../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            EditUserFrom},
        name: "user-from",
        data() {
            return {
                loading:false,
                currentPage: 1,
                pageSize: 20,
                total: 0,
                height:250,
                tableData: [],
                id:'',

                type:0,
                visible:false,

                customFrom: '',

            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight - 320;
                console.log(this.height)
            },0)
            this.getDataList();
        },
        watch:{
            visible(newval,oldval){
                if(!newval){
                    this.getDataList();
                }
            },
        },
        methods: {
            searchList(){
                this.currentPage=1;
                this.getDataList();
            },
            getDataList(){
                this.loading=true;
                this.$axios.post('/customFrom/customFromList',{
                    storeId: this.$root.getStorage('storeId'),
                    customFrom:this.customFrom,
                    pageSize:this.pageSize,
                    pageNum:this.currentPage
                }).then(res=>{
                    console.log(res)
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                    this.loading=false;
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            delUserFrom(id){
                this.$axios.post('/customFrom/customFromDeleteByIds',id).then(res=>{
                    this.$message.success('删除客户来源成功')
                    this.getDataList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            addUserFrom(){
                this.type=0;
                this.visible=true;
            },
            editUserFrom(id){
                this.id=id;
                this.visible=true;
                this.type=1;
            },
            manageUserFrom(state,info){
                this.$axios.post('/customFrom/customFromUpdate',{
                    id:info.id,
                    storeId: this.$root.getStorage('storeId'),
                    customFromState:state,
                    orderIndex: info.orderIndex,
                    customFrom: info.customFrom
                }).then(res=>{
                    this.$message.success('顾客来源'+(state=='0'?'停用':'启用')+'成功！');
                    this.getDataList();
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getDataList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getDataList();
                console.log(`当前页: ${val}`);
            }
        },
    }
</script>

<style scoped lang="scss">
    .field {
    .content1 {
    .textnowrap {
        font-size: 13px;
        color: #333;
    }
    .date {
        min-width: 100px;
    }
    }
    }
</style>